module.exports = __webpack_public_path__ + "img/icon-facebook.5a9d954e.svg";